import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import notificationService from '../../../../services/notification/notification.service';
import { ProtectedRoute } from '../../../Auth/ProtectedRoute/ProtectedRoute ';
import InspectionPanelNative from './InspectionPanel.native';

const InspectionPanelContainer = () => {
  const history = useHistory();

  const [showVehicleError, setShowVehicleError] = React.useState<boolean>(false);

  const goToNewInspection = () => {
    history.push('new-inspection/profile');
  }

  const closeVehicleError = () => {
    setShowVehicleError(false);
  }

  useEffect(() => {
    notificationService.requestPermission();

    const onVehicleTypeError = () => {
      setShowVehicleError(true);
    };
    document.addEventListener('vehicleTypeError', onVehicleTypeError);

    return () => document.removeEventListener('vehicleTypeError', onVehicleTypeError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProtectedRoute>
      <InspectionPanelNative
        goToNewInspection={goToNewInspection}
        showVehicleError={showVehicleError}
        closeVehicleError={closeVehicleError}
      />
    </ProtectedRoute>
  );
};

export default InspectionPanelContainer;
